import { render, staticRenderFns } from "./TwoLabel.vue?vue&type=template&id=ad1af464&scoped=true&"
import script from "./TwoLabel.vue?vue&type=script&lang=js&"
export * from "./TwoLabel.vue?vue&type=script&lang=js&"
import style0 from "./TwoLabel.vue?vue&type=style&index=0&id=ad1af464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1af464",
  null
  
)

export default component.exports